(function(){
  function init(){
    const root = document.querySelector('.hcs-calc');
    if (!root) return;
    if (root.dataset.hcsInlineInit) return; root.dataset.hcsInlineInit = '1';

    const $ = s => root.querySelector(s);
    const form = $('#hcsCalcForm');
    const results = $('#hcsResults');
    const cards = $('#resultsCards');
    const tiers = $('#tiersSection');
    const topline = $('#toplineMsg');

    if (!form || !results || !cards || !tiers || !topline) return;

    const currencyISO = (window.Shopify && Shopify.currency && Shopify.currency.active) || (document.documentElement.getAttribute('data-shopify-currency') || 'USD');
    const currencySymbol = root.dataset.currencySymbol || '$';
    root.querySelectorAll('.cur').forEach(el=>el.textContent=currencySymbol);

    const toN=v=>{const n=Number(v);return isFinite(n)?n:0};
    function compute(p){
      const BAG=340, SHOT=p.shotType==='single'?7:14, GAL=128, L2=67.628;
      const milkOz=p.milkUnit==='gallon'?GAL:L2;
      const coffeePerDrink=(p.bagPrice>0?(p.bagPrice/BAG):0)*SHOT;
      const milkPerDrinkCost = (p.drinkType === 'black')
        ? 0
        : (p.milkPrice>0?(p.milkPrice/milkOz):0)*Math.max(0,p.milkPerDrink);
      const costHome=coffeePerDrink+milkPerDrinkCost;
      const days = p.daysPerMonth && isFinite(p.daysPerMonth) ? p.daysPerMonth : 30;
      const drinks=p.cupsPerDay*days;
      const cafe=drinks*p.cafePrice, home=drinks*costHome, ms=cafe-home, ys=ms*12;
      return {monthlyCafeSpend:cafe, monthlyHomeCost:home, monthlySavings:ms, yearlySavings:ys};
    }
    function fmt(n,c){const iso=c||currencyISO;try{return new Intl.NumberFormat('en-CA',{style:'currency',currency:iso}).format(Number(n||0))}catch(_){const v=Math.round(Number(n||0)*100)/100;return currencySymbol+v.toFixed(2)}}
    function segment(ms){ms=Number(ms||0);if(ms<=0)return'ccunder500';const m=p=>p/ms; if(m(3000)<=60)return'ccover3000'; if(m(2000)<=60)return'ccover2000'; if(m(1000)<=60)return'ccover1000'; if(m(500)<=60)return'ccover500'; return'ccunder500'}
    function bestPrice(ms){ms=Number(ms||0);if(ms<=0)return 0; const c=p=>ms*60>=p; if(c(3000))return 3000; if(c(2000))return 2000; if(c(1000))return 1000; if(c(500))return 500; return 0}

    function updateURL(p,r){
      const q=new URLSearchParams();
      [['cups_per_day',p.cupsPerDay],['cafe_price',p.cafePrice],['bag_price',p.bagPrice],['milk_price',p.milkPrice],
       ['milk_unit',p.milkUnit],['shot_type',p.shotType],['drink_type',p.drinkType||'milk'],['milk_per_drink_oz',p.milkPerDrink],['days_per_month',p.daysPerMonth||30],
       ['currency',currencyISO],
       ['monthly_cafe_spend',Math.round(r.monthlyCafeSpend*100)/100],['monthly_home_cost',Math.round(r.monthlyHomeCost*100)/100],
       ['monthly_savings',Math.round(r.monthlySavings*100)/100],['yearly_savings',Math.round(r.yearlySavings*100)/100],
       ['apr_note','true'],['calc_completed','true'],['segment',segment(r.monthlySavings)],['best_price',bestPrice(r.monthlySavings)]
      ].forEach(([k,v])=>q.set(k,String(v)));
      const url=location.pathname+'?'+q.toString();
      try{history.replaceState(null,'',url)}catch(_){/*noop*/}
    }

    function render(r){
      if(results.hasAttribute('hidden')){ results.removeAttribute('hidden'); }
      const bp=bestPrice(r.monthlySavings);
      if (bp>0) {
        const addNet = (r.yearlySavings*5) - bp;
        topline.textContent = `Based on your consumption, your current spending can buy you a ${fmt(bp)} machine over 5 years — plus approximately ${fmt(addNet)} in additional savings.`;
      } else {
        topline.textContent = 'Based on your consumption, a positive five-year return is not reached for these tiers.';
      }
      const kpiItems = [
        ['Monthly Café Spend',fmt(r.monthlyCafeSpend)],
        ['Monthly At‑Home Cost',fmt(r.monthlyHomeCost)],
        ['Monthly Savings',fmt(r.monthlySavings)],
        ['Yearly Savings',fmt(r.yearlySavings)]
      ].map(([h,v])=>`<div class="card"><h3>${h}</h3><p>${v}</p></div>`).join('');
      cards.innerHTML = `<div class="cards-grid">${kpiItems}</div>`;
      cards.setAttribute('aria-busy','false');
      const amounts=[500,1000,2000,3000];
      const items=amounts.map(price=>{
        const net=(r.yearlySavings*5)-price;
        const months=r.monthlySavings>0?Math.ceil(price/r.monthlySavings):null;
        const monthsTxt=(months&&isFinite(months))?months:'—';
        return `<div class=\"tier-card\"><h4>${fmt(price)} Coffee Machine</h4><p class=\"meta\">Net savings over 5 years: <strong>${fmt(net)}</strong></p><p class=\"meta\">Months to break even: <strong>${monthsTxt}</strong></p></div>`;
      }).join('');
      tiers.innerHTML = `<div class="tier-grid">${items}</div>`;
    }

    function read(){
      const fd=new FormData(form);
      return {
        cupsPerDay:toN(form.cupsPerDay.value),
        cafePrice:toN(form.cafePrice.value),
        bagPrice:toN(form.bagPrice.value),
        milkPrice:toN(form.milkPrice.value),
        milkUnit:fd.get('milkUnit')||'gallon',
        shotType:fd.get('shotType')||'single',
        drinkType:fd.get('drinkType')||'milk',
        milkPerDrink:toN(form.milkPerDrink.value||6),
        daysPerMonth:toN((form.daysPerMonth && form.daysPerMonth.value) || 30)
      };
    }

    function onCalc(){
      const p=read();
      if(p.cupsPerDay<=0||p.cafePrice<=0||p.bagPrice<=0||p.milkPrice<0){alert('Please complete all required fields with valid values.');return;}
      const r=compute(p);
      updateURL(p,r);
      render(r);
    }

    const submitBtn = root.querySelector('#hcsCalcSubmit');
    if (submitBtn) submitBtn.addEventListener('click', onCalc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
